import { observable } from 'mobx';
import Config from '../../domain/entities/Config/Config';
import { EXTERNAL_ROUTES } from '../../routes';

interface IRoutesServiceConfig {
  config: Config;
}

export const enum ExternalRoute {
  CART = 'CART',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  SIGNED_OUT = 'SIGNED_OUT',
}

export default class Routes {
  @observable config: Config;

  constructor(options: IRoutesServiceConfig) {
    this.config = options.config;
  }

  getExternalRoute(route: ExternalRoute): string {
    return this.config?.externalRoutes?.[route] || EXTERNAL_ROUTES[route];
  }

  redirect(route: ExternalRoute, params?: string): void {
    const url = this.getExternalRoute(route);
    window.location.href = params ? `${url}&${params}` : url;
  }
}
